import { useState } from "react";
import type { QuestionImportCandidate } from "../../../../packages/import-contracts/src/index";
import { api } from "../api";

export function ReviewScreen() {
  const [importJobId, setImportJobId] = useState("");
  const [candidates, setCandidates] = useState<QuestionImportCandidate[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [note, setNote] = useState<string | null>(null);

  async function load() {
    setError(null);
    setNote(null);
    try {
      const rows = await api.listCandidates(importJobId || undefined);
      setCandidates(rows);
      if (rows.length === 0) setNote("Aday bulunamadı.");
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  async function act(id: string, action: "approve" | "reject" | "publish") {
    setError(null);
    setNote(null);
    try {
      if (action === "approve") await api.approveCandidate(id);
      else if (action === "reject") await api.rejectCandidate(id);
      else await api.publishCandidate(id);
      await load();
      if (action === "publish") setNote(`Aday ${id} yayınlandı.`);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  return (
    <div className="panel">
      <h2>Aday inceleme</h2>
      <label>Import job id (boş = son adaylar)</label>
      <input value={importJobId} onChange={(e) => setImportJobId(e.target.value)} placeholder="job-uuid" />
      <button className="primary" onClick={load}>Listele</button>

      {note && <p className="ok">{note}</p>}
      {error && <p className="error">{error}</p>}

      {candidates.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Stem</th>
              <th>Güven</th>
              <th>Durum</th>
              <th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {candidates.map((c) => (
              <tr key={c.id}>
                <td>{c.questionNumber ?? "-"}</td>
                <td>{c.stemText ?? <span className="muted">(boş)</span>}</td>
                <td>{Math.round(c.confidence * 100)}%</td>
                <td><span className="badge">{c.status}</span></td>
                <td style={{ display: "flex", gap: 6 }}>
                  <button className="ghost" onClick={() => act(c.id, "approve")}>Onayla</button>
                  <button className="ghost danger" onClick={() => act(c.id, "reject")}>Reddet</button>
                  <button
                    className="ghost"
                    disabled={c.status !== "approved"}
                    onClick={() => act(c.id, "publish")}
                  >
                    Yayınla
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
